import type {
  StockTransfer,
  StockTransferItem,
  StockTransferStatus,
} from '@/domain/entities/stock-transfer.entity'
import type { StockTransferDto, StockTransferItemDto } from './stock-transfer.dto'

export const stockTransferMapper = {
  toStockTransferItem(dto: StockTransferItemDto): StockTransferItem {
    return {
      id: dto.id,
      ingredientId: dto.ingredient_id,
      ingredientName: dto.ingredient_name,
      unitId: dto.unit_id,
      unitName: dto.unit_name,
      qtySent: dto.qty_sent,
      qtyReceived: dto.qty_received,
      cost: dto.cost,
      differenceReason: dto.difference_reason,
    }
  },

  toStockTransfer(dto: StockTransferDto): StockTransfer {
    return {
      id: dto.id,
      transferNo: dto.transfer_no,
      fromOutletId: dto.from_outlet_id,
      fromOutletName: dto.from_outlet_name,
      toOutletId: dto.to_outlet_id,
      toOutletName: dto.to_outlet_name,
      status: (dto.status as StockTransferStatus) || 'pending',
      totalCost: dto.total_cost,
      note: dto.note,
      dispatchedAt: dto.dispatched_at,
      dispatchedBy: dto.dispatched_by,
      receivedAt: dto.received_at,
      receivedBy: dto.received_by,
      createdBy: dto.created_by,
      createdAt: dto.created_at,
      updatedAt: dto.updated_at,
      items: dto.items ? dto.items.map(stockTransferMapper.toStockTransferItem) : undefined,
    }
  },
}
